module.exports = "pegasus/assets/frame-large-facebook.png";